import { type ReactNode, createContext, useContext } from "react";

import { noop } from "~/tools/noop";

export interface ExplorationDrawerContextValue {
	children: ReactNode;
	onClose: VoidFunction;
}

const ExplorationDrawerChildrenContext = createContext<ExplorationDrawerContextValue>({
	children: null,
	onClose: noop,
});

export const ExplorationDrawerContextProvider = ExplorationDrawerChildrenContext.Provider;

export function useExplorationDrawerContext(): ExplorationDrawerContextValue {
	return useContext(ExplorationDrawerChildrenContext);
}
